module.exports = __webpack_public_path__ + "img/fabriqblog-original-480.c81b164a.png";